import { Component } from '@angular/core';

@Component({
  selector: 'app-anonymous-layout',
  templateUrl: './anonymous-layout.component.html',
  styleUrl: './anonymous-layout.component.css'
})
export class AnonymousLayoutComponent {

}
